import React from 'react';
const Spearator = () => {
    return React.createElement("div", { className: "w-100 mx-2 separator separator-dots asset__separator" });
};
export default Spearator;
